import type { AcceleratorState } from '../lib/accelerator';
import type { BasicUserProfile } from '../lib';
import { z } from 'zod';
import { telegramHandleRegex } from '../lib';
export const acceleratorProfileSchema = z.object({
  email: z.string().email(),
  telegramUsername: z.string().regex(telegramHandleRegex, {
    message:
      'Telegram handle must be between 5 and 32 characters and can only contain letters, numbers, and underscores.',
  }),
  otherContactInfo: z.string().optional(),
  profileAppendix: z.string().optional(),
});

export type AcceleratorProfileBody = z.infer<typeof acceleratorProfileSchema>;

export type GetAcceleratorMembershipResponse = AcceleratorState;

export const generateMentorReferralCodeSchema = z.object({
  note: z
    .string()
    .max(100, 'Note must be less than 100 characters')
    .optional()
    .default(''),
});

export type GenerateMentorReferralCodeBody = z.infer<
  typeof generateMentorReferralCodeSchema
>;

export type GenerateMentorReferralCodeResponse = {
  url: string;
};

interface RedeemedBy extends BasicUserProfile {
  email: string;
}

export type ListMentorReferralsResponse = {
  data: {
    id: number;
    code: string;
    note: string;
    createdAt: Date;
    redeemedAt: Date | null;
    expiresAt: Date;
    redeemedBy: RedeemedBy | null;
    url: string;
  }[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
};

export const listMentorReferralsSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(10),
});

export type ListMentorReferralsParams = z.infer<
  typeof listMentorReferralsSchema
>;
